import { Mappable, Mapped } from '../../rest/decorators/mapped'

@Mapped({})
export class Day extends Mappable {
  id!: number
  name!: string

  static create<Data>(attrs: Data) {
    return new Day().map(attrs)
  }

  static all() {
    return [
      Day.create({ id: 1, name: 'Monday' }),
      Day.create({ id: 2, name: 'Tuesday' }),
      Day.create({ id: 3, name: 'Wednesday' }),
      Day.create({ id: 4, name: 'Thursday' }),
      Day.create({ id: 5, name: 'Friday' }),
      Day.create({ id: 6, name: 'Saturday' }),
      Day.create({ id: 7, name: 'Sunday' }),
    ]
  }
}
